(() => {
  'use strict';

  const assignment =
    Object.freeze({
      id:
        'rec_always_on_20260921',
      group:
        'treatment',
      source:
        'always_on',
      assignedAt:
        new Date().toISOString(),
      isPreview:
        new URLSearchParams(
          window.location.search
        ).has(
          'preview_theme_id'
        ) ||
        Boolean(
          window.Shopify?.designMode
        ),
    });

  window
    .SctRecommendationExperiment =
      Object.freeze({
        ...assignment,

        isTreatment() {
          return true;
        },

        isControl() {
          return false;
        },

        getAssignment() {
          return assignment;
        },

        reset() {
          return true;
        },
      });

  document.documentElement
    .dataset
    .sctRecExperiment =
      'treatment';

  if (
    new URLSearchParams(
      window.location.search
    ).get('sct_debug') === '1'
  ) {
    console.log(
      '[SCT Recommendation] Always on',
      assignment
    );
  }
})();